import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { FormattedMessage, Link, useIntl } from "gatsby-plugin-intl";
export const _frontmatter = {
  "title": "Intro"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1><img src="../logo_metabravo.svg" /></h1>
    <p><FormattedMessage id="description" mdxType="FormattedMessage" /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      